import React from 'react';
import {MinusCircle} from 'lucide-react';
import { FormComponent} from "../../DynamicFormTypes.ts";
import {renderComponent} from "../../dyanimcFormUtil.tsx";
import {useModifiedComponents} from "./datagridUtil.tsx";
import {getColSpan} from "../sharedStyles.tsx";

// Define props interface for the DataGridRow component
interface DataGridRowProps {
    field: Record<string, any>;
    index: number;
    components: Array<FormComponent>;
    fieldKey: string;
    minLength?: number;
    totalCount: number;
    handleRemoveRow: (index: number) => void;
    itemName: string;
}

const DataGridColumnRenderer: React.FC<DataGridRowProps> = (({
                                                                field,
                                                                index,
                                                                components,
                                                                fieldKey,
                                                                minLength,
                                                                totalCount,
                                                                handleRemoveRow,
    itemName
                                                            }) => {

    const modifiedComponents = useModifiedComponents(components, fieldKey, index, field);

    const renderComponents = () => {
        return modifiedComponents.map((modifiedComponent, compIndex) => {
            return (
                <div
                    key={`${field.id}-comp-${compIndex}`}
                    className={`${getColSpan(modifiedComponent.width || 12)}`}
                >
                    {renderComponent({
                        component: modifiedComponent,
                    })}
                </div>
            );
        });
    };

    return (
        <div className="">
            {/* Column header with item number and remove button */}
            <div className="bg-gray-200 px-4 py-2 flex justify-between items-center sticky top-0 z-10">
                <div className="text-sm font-medium text-gray-700">
                    {itemName} {index + 1}
                </div>
                <button
                    type="button"
                    onClick={() => handleRemoveRow(index)}
                    disabled={minLength !== undefined && totalCount <= minLength}
                    className={`
                        p-1.5 rounded-full text-red-500 hover:bg-red-50 transition-colors
                        focus:outline-none focus:ring-2 focus:ring-red-400 focus:ring-opacity-50
                        ${minLength !== undefined && totalCount <= minLength ? 'opacity-40 cursor-not-allowed' : ''}
                    `}
                    aria-label="Remove column"
                >
                    <MinusCircle className="h-5 w-5" />
                </button>
            </div>

            {/* Stack components vertically */}
            <div className={`gap-x-1 p-2 ${index % 2 === 0 ? 'bg-white' : 'bg-gray-100'} min-h-[200px] grid grid-cols-12`}>
                {renderComponents()}
            </div>
        </div>
    );
});

// Set display name for React DevTools
export const DataGridColumn = React.memo(DataGridColumnRenderer);